// src/locales/en.sidebars.ts

const sidebars = {  

    // SidebarMain
    mainSidebar: {    
        search: {
          galleryPlaceholder: '🔍 Search Gallery...',
          likesPlaceholder: '🔍 Search My Likes...',
          followingPlaceholder: '🔍 Search My Feed...',
        },
        location: {
          tooltip:
            'Requests your device location (permission required) and updates nearby content.',
        },
        buttons: {
          gallery: 'Gallery',
          changeLocation: 'Change Location',
          myPreferences: 'My Feed',
          myLikes: 'My Likes',
          chat: 'Chat',
          myProfile: 'My Profile',
          settings: 'Settings',
          upload: 'Upload Post',
          logout: 'Logout',
          ads: 'Advertisement'
        },

        footer: {
  helpSupport: "Help & Support",
  privacyPolicy: "Privacy Policy",
  termsOfUse: "Terms of Use",
},

      },

      //Sidebar My Profile
      sidebarMyProfile: {
        buttons: {
          profile: 'My Profile',
          postings: 'My Posts',
          favorites: 'Following Posts',
          followers: 'Followers',
          gallery: 'Gallery',
          notifications: 'Notifications',
          myPreferences: 'My Feed',
          myLikes: 'My Likes',
          chat: 'Chat',
          settings: 'Settings',
          logout: 'Logout',
        },

        sections: {
          profile: 'Profile Management',
          noti: 'Notifications',
          nav: 'Navigation',
          chat: 'Chat',
          



        }
      },

//SidebarGalleryPosting
      galleryPostingSidebar: {
        heading: 'Upload Your Post',
        buttons: {
          post: 'Post',
          cancel: 'Cancel',
        },
        leftLabel: '({{count}} left for today)',
      },     

      
      //SidebarGalleryEditPosting
      galleryEditSidebar: {
        heading: 'Edit Your Post',
        buttons: {
          save: 'Save',
          cancel: 'Cancel',
        },
      },

      //SettingsSidebar
      settingsSidebar: {
        sections: {
          settings: 'Settings',
          myProfile: 'My Profile',
          navigation: 'Navigation',
        },
        buttons: {
          overview: 'Overview',
          account: 'Account Settings',
          dataPrivacy: 'Data & Privacy',
          security: 'Security',
          profileManagement: 'Profile Management',
          helpSupport: 'Help & Support',
          myProfile: 'My Profile',
          gallery: 'Gallery',
          myPreferences: 'My Feed',
          myLikes: 'My Likes',
          logout: 'Logout',
        },
      },

      //SidebarVisitor
      sidebarVisitor: {
        headers: {
          postsBy: 'Posts by:',
          chat: 'Chat',
          mainNav: 'Main Navigation',
          profileActions: 'Profile Actions',
        },
        labels: {
          userFallback: 'User',
          thisUser: 'this user',
        },
        buttons: {
          chatWithName: 'Chat with {{name}}',
          chatShort: 'Chat',
          backToGallery: '🖼 Gallery',
          following: 'Following',
          favorites: 'My Feed',  
          followers: 'My Followers',
          follow: 'I follow...',
          unfollow: 'Unfollow',
          block: 'Block',
          unblock: 'Unblock',
          blockAndReport: 'Block & Report',
        },
        tooltips: {
          chatWith: 'Chat with {{name}}',
        },
        confirm: {
          block: 
            'Block {{name}}? They won’t be able to interact with you, and you won’t see each other’s posts or messages.',
        },
        alerts: {
          actionFailed: 'Action failed',
          blockSuccess: 'User blocked.',
          blockError: 'Block failed',
          unblockSuccess: 'User unblocked.',
          unblockError: 'Unblock failed',
        },
      },

      //SidebarChat
      sidebarChat: {
        actions: {
          backToGallery: 'Back to Gallery',
        },
        search: {
          placeholder: 'Search user by profile name…',
        },
        list: {
          activeTitle: 'Active Chats',
        },
        preview: {
          image: 'Photo',
          video: 'Video',
          audio: 'Audio',
          media: 'Media',
        },
        unreadLabel: '{{count}} unread',
        menu: {
          moreOptionsAria: 'More options',
          moreOptionsTitle: 'More options',
          hideChat: 'Hide chat',
          deleteChat: 'Delete chat',
        },
      },
      
} as const;      
  
export default sidebars;